import MessagePriceComponent from "./MessagePriceComponent";

export default MessagePriceComponent;
